export const products = [
  {
    id: 1,
    name: "Kesar Glow Face Serum",
    category: "Serum",
    price: 799,
    rating: 4.9,
    description: "Saffron, niacinamide, and hyaluronic acid serum for bright, hydrated skin.",
    benefits: ["Glow boost", "Hydration", "Even tone"],
    image: "https://images.unsplash.com/photo-1620916566398-39f1143ab7be?auto=format&fit=crop&w=900&q=80",
  },
  {
    id: 2,
    name: "Haldi Chandan Moisturizer",
    category: "Moisturizer",
    price: 649,
    rating: 4.8,
    description: "Lightweight turmeric and sandalwood moisturizer for daily barrier care.",
    benefits: ["Softens skin", "Calms dryness", "Non-greasy"],
    image: "https://images.unsplash.com/photo-1608248543803-ba4f8c70ae0b?auto=format&fit=crop&w=900&q=80",
  },
  {
    id: 3,
    name: "SPF 50 Matte Sunscreen",
    category: "Sunscreen",
    price: 549,
    rating: 4.7,
    description: "Broad spectrum SPF 50 sunscreen made for Indian weather and no white cast.",
    benefits: ["SPF 50 protection", "Matte finish", "Sweat friendly"],
    image: "https://images.unsplash.com/photo-1556228720-195a672e8a03?auto=format&fit=crop&w=900&q=80",
  },
  {
    id: 4,
    name: "Neem Tulsi Face Wash",
    category: "Face Wash",
    price: 299,
    rating: 4.8,
    description: "Neem and tulsi face wash for fresh, balanced skin without tightness.",
    benefits: ["Deep cleanse", "Oil control", "Gentle foam"],
    image: "https://images.unsplash.com/photo-1601049541289-9b1b7bbbfe19?auto=format&fit=crop&w=900&q=80",
  },
];

export const categories = [
  "Face Wash",
  "Serum",
  "Moisturizer",
  "Sunscreen",
  "Ayurvedic Care",
];
